import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'react';
import { BoldHeading } from '@lendi-jam/atoms';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { gte, between } from '@lendi-ui/breakpoint';
import { bg, color } from '@lendi-ui/color';
import Container from '@lendi-ui/container';
import { py, px, m, pl, pr } from '@lendi-ui/spacing';
import { Body } from '@lendi-ui/typography';
import styled from 'styled-components';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21;
var TableHeadingContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n\n  ", "\n"])), function (_ref) {
  var colorVariant = _ref.colorVariant;
  return bg(colorVariant === 'white' ? 'shade.0' : 'shade.25');
}, py('md'), px('xs'), function (_ref2) {
  var colorVariant = _ref2.colorVariant;
  return gte('lg')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n  "])), px(colorVariant === 'white' ? 'nil' : 'md'));
});
var TableContainer = styled(Container)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), between('xs', 'lg')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    width: 100%;\n    ", "\n  "])), m('nil')));
var TableComponent = styled.table(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: ", ";\n  width: 100%;\n\n  ", "\n"])), function (_ref3) {
  var dataColumns = _ref3.dataColumns;
  return dataColumns && dataColumns > 2 ? 'block' : 'table';
}, gte('lg')(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    display: table;\n  "]))));
var TableBody = styled(Body)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 50%;\n\n  p {\n    ", "\n  }\n\n  ", "\n"])), m('nil'), gte('lg')(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    width: auto;\n  "]))));
var TableHeader = styled.th(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: ", ";\n  ", "\n\n  text-align: ", ";\n  ", "\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref4) {
  var dataColumns = _ref4.dataColumns;
  return dataColumns && dataColumns > 2 ? 'none' : 'table-cell';
}, function (_ref5) {
  var dataColumns = _ref5.dataColumns,
    colorVariant = _ref5.colorVariant;
  return bg(dataColumns && dataColumns <= 2 && colorVariant === 'white' ? 'shade.25' : 'shade.0');
}, function (_ref6) {
  var alignment = _ref6.alignment;
  return alignment;
}, px('xs'), py('xs'), gte('md')(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    ", "\n  "])), px('xl')), function (_ref7) {
  var colorVariant = _ref7.colorVariant;
  return gte('lg')(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n        display: table-cell;\n        ", "\n        &:first-of-type {\n          ", "\n        }\n\n        &:last-of-type {\n          ", "\n        }\n        ", ""])), px('xs'), pl('md'), pr('md'), bg(colorVariant === 'white' ? 'shade.25' : 'shade.0'));
});
var TableData = styled.td(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: ", ";\n  ", "\n\n  text-align: ", ";\n  border-bottom: 1px solid ", ";\n  ", "\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref8) {
  var dataColumns = _ref8.dataColumns;
  return dataColumns && dataColumns > 2 ? 'flex' : 'table-cell';
}, function (_ref9) {
  var colorVariant = _ref9.colorVariant,
    dataColumns = _ref9.dataColumns;
  return dataColumns && dataColumns <= 2 ? bg(colorVariant === 'white' ? 'shade.0' : 'shade.25') : '';
}, function (_ref10) {
  var alignment = _ref10.alignment;
  return alignment;
}, color('shade.50'), px('xs'), py('sm'), gte('md')(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    ", "\n  "])), px('xl')), function (_ref11) {
  var colorVariant = _ref11.colorVariant;
  return gte('lg')(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n        display: table-cell;\n        ", "\n        &:first-of-type {\n          ", "\n        }\n\n        &:last-of-type {\n          ", "\n        }\n        ", ""])), px('xs'), pl('md'), pr('md'), bg(colorVariant === 'white' ? 'shade.0' : 'shade.25'));
});
var TableBodyContainer = styled.tbody(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  display: ", ";\n\n  ", "\n"])), function (_ref12) {
  var dataColumns = _ref12.dataColumns;
  return dataColumns && dataColumns > 2 ? 'block' : 'table-row-group';
}, gte('lg')(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n    display: table-row-group;\n  "]))));
var TableRow = styled.tr(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  display: ", ";\n\n  &:nth-child(2n) {\n    td,\n    th {\n      ", "\n\n      ", "}\n    }\n  }\n\n  &:last-child {\n    td {\n      border-bottom: initial;\n    }\n  }\n\n  ", "\n"])), function (_ref13) {
  var dataColumns = _ref13.dataColumns;
  return dataColumns && dataColumns > 2 ? 'block' : 'table-row';
}, function (_ref14) {
  var dataColumns = _ref14.dataColumns,
    colorVariant = _ref14.colorVariant;
  return dataColumns && dataColumns > 2 ? bg('shade.25') : bg(colorVariant === 'white' ? 'shade.0' : 'shade.25');
}, function (_ref15) {
  var colorVariant = _ref15.colorVariant;
  return gte('lg')(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n        ", "\n      "])), bg(colorVariant === 'white' ? 'shade.0' : 'shade.25'));
}, gte('lg')(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n    display: table-row;\n  "]))));
var TableMobileHeader = styled(Body)(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  width: 50%;\n  ", "\n"])), gte('lg')(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n      display: none;\n  "]))));

var _excluded = ["variant", "alignment", "children"];
var RowWrapper = function RowWrapper(_ref) {
  var variant = _ref.variant,
    alignment = _ref.alignment,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return variant === 'header' ? /*#__PURE__*/jsx(TableHeader, _objectSpread(_objectSpread({
    alignment: alignment
  }, props), {}, {
    children: children
  })) : /*#__PURE__*/jsx(TableData, _objectSpread(_objectSpread({
    alignment: alignment
  }, props), {}, {
    children: children
  }));
};
var Table = function Table(_ref2) {
  var rows = _ref2.rows,
    heading = _ref2.heading,
    subheading = _ref2.subheading,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'white' : _ref2$variant;
  var maxColumns = Math.max.apply(Math, _toConsumableArray(rows.map(function (row) {
    return row.columns.length;
  })));
  return /*#__PURE__*/jsxs(TableContainer, {
    children: [(heading || subheading) && /*#__PURE__*/jsxs(TableHeadingContainer, {
      colorVariant: variant,
      children: [heading && /*#__PURE__*/jsx(BoldHeading, {
        size: "md",
        color: "shade.700",
        children: heading
      }), subheading && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx(TableBody, {
          size: "xxs",
          color: "shade.700",
          mt: "xxs",
          children: subheading
        })
      })]
    }), /*#__PURE__*/jsx(TableComponent, {
      cellSpacing: "0",
      cellPadding: "0",
      dataColumns: maxColumns,
      children: /*#__PURE__*/jsx(TableBodyContainer, {
        dataColumns: maxColumns,
        children: rows.length && rows.map(function (row, rowIndex) {
          var headerRow = rows[0].columns;
          var type = row.type,
            columns = row.columns;
          return /*#__PURE__*/jsx(TableRow, {
            colorVariant: variant,
            dataColumns: maxColumns,
            children: columns.map(function (column, columnIndex) {
              return /*#__PURE__*/jsxs(RowWrapper, {
                variant: type,
                alignment: column.alignment || 'left',
                colorVariant: variant,
                dataColumns: maxColumns,
                children: [maxColumns > 2 && /*#__PURE__*/jsx(TableMobileHeader, {
                  children: headerRow[columnIndex].value
                }), /*#__PURE__*/jsx(TableBody, {
                  children: column.value
                })]
              }, "item-body-".concat(rowIndex, "-").concat(columnIndex));
            })
          }, "item-row-".concat(rowIndex, "-").concat(type));
        })
      })
    })]
  });
};

export { Table as default };
